module.exports = __webpack_public_path__ + "img/bannberpc.59920107.png";